module.exports = __webpack_public_path__ + "static/Fallback07-f9d6e997477fe83f0509943c9baca8f8.jpg";